import axios from "axios";
import deepdash from "deepdash";
import jwt_decode from "jwt-decode";
import lodash from "lodash";
import {
  default as React,
  Suspense,
  useEffect,
  useState,
  createContext,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import CacheRoute, { CacheSwitch } from "react-router-cache-route";
import {
  BrowserRouter,
  BrowserRouter as Router,
  Route,
  useHistory,
} from "react-router-dom";
import { setStatusAction } from "redux/reducers/cachedStatus";
import { initTop, loadAlert } from "redux/reducers/top";
import {
  loginRequestAction,
  setUserInfoAction,
  logoutAction,
} from "redux/reducers/user";
import "./App.scss";
import Top from "./components/ui/Top";
import Routes from "./routes/Routes";
import { Box } from "@mui/material";
import { Cookies } from "react-cookie";
import AuthRoute from "./helper/AuthRoute";
import DrawerComplete from "components/ui/drawer-complete";
import Bottom from "components/ui/Bottom";
import CommonComponent from "components/ui/common-component";
import { rem, setCookiesSync } from "assets/js/common";
import AppCardDrawer from "components/ui/app-card-drawer";
import Loading from "components/ui/loading";
import { loadingState } from "redux/reducers/loading";
import { goAppPath, getAppData, setAppData } from "assets/js/apphandle";
import NotFound from "pages/not-found";
import DrawerTutorial from "components/tutorial";
import { refreshFavInfo } from "assets/js/favInfo";
import { loadMainAction } from "redux/reducers/home";
let previousPath = "/";

const _ = deepdash(lodash);
const cookies = new Cookies();

function RouteWatch(props) {
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    userInfo,
    loginFail,
    loginFailReason,
    userAuth,
    managerRole,
    accessiblePages,
  } = useSelector((state) => state.user);

  useEffect(() => {
    return history.listen((location) => {
      console.log(`You changed the page to: ${location.pathname}`);

      dispatch(initTop(true));
      beforeMounted(previousPath, location.pathname);
      // authCheck(location.pathname);
      goAppPath(location.pathname);
      previousPath = location.pathname;
    });
  }, [history]);

  const authCheck = (next) => {
    if (managerRole) {
      let menu = _.find(managerRole.managerRole.managerRoleMenus, (item) => {
        return next.indexOf(item.managerMenu.url) > -1;
      });

      if (!menu) window.location.href = "/login";
    }
  };

  const beforeMounted = (prev, next) => {
    _.forEach(Routes, (route) => {
      if (route.path == next) {
        if (route.cache && route.cache == true) {
          let cachedPage = _.find(route.cacheLocation, (item) => {
            return comparePath(item, prev);
          });

          if (!cachedPage) {
            dispatch(setStatusAction("reset"));
          } else {
            dispatch(setStatusAction("fetch"));
          }
        }
      }
    });
  };

  const comparePath = (path1, path2) => {
    if (path1.indexOf(":") > -1) {
      let arr1 = path1.split("/");
      let arr2 = path2.split("/");
      let isSame = true;

      for (let i = 0; i < arr1.length; i++) {
        if (arr1[i].indexOf(":") == -1) {
          if (arr1[i] != arr2[i]) {
            isSame = false;
          }
        }
      }

      return isSame;
    } else {
      return path1 == path2 ? true : false;
    }
  };

  return <></>;
}

function App(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  const {
    userInfo,
    loginFail,
    loginFailReason,
    userAuth,
    accessiblePages,
    managerRole,
  } = useSelector((state) => state.user);

  const loadingState = useSelector((state) => state.loading);

  const [path, setPath] = useState(location.pathname.split("/"));
  const { tokenRefreshFail, loginSuccess, loginResponseData } = useSelector(
    (state) => state.user,
  );
  const [isRender, setIsRender] = useState(false);

  const [fullOpen, setFullOpen] = useState(false);

  const handleDialogFullClose = () => {
    setFullOpen(false);
  };

  const handleVisibilityChange = () => {
    let data = cookies.getAll();
    setAppData(data);
  };

  useEffect(() => {
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.addEventListener("visibilitychange", handleVisibilityChange);
    };
  });

  let cookieExpires = new Date();
  cookieExpires.setDate(cookieExpires.getDate() + 180);

  useEffect(async () => {
    if (loginSuccess) {
      const myDecodedToken = jwt_decode(loginResponseData.accessToken);
      dispatch(setUserInfoAction(myDecodedToken));

      axios.defaults.headers.Authorization = `${loginResponseData.tokenType} ${loginResponseData.accessToken}`;

      setCookiesSync(
        "X-AUTH-TOKEN",
        `${loginResponseData.tokenType} ${loginResponseData.accessToken}`,
      );
      // cookies.set(
      //   "X-AUTH-TOKEN",
      //   `${loginResponseData.tokenType} ${loginResponseData.accessToken}`,
      //   {
      //     path: "/",
      //     expires: cookieExpires,
      //   }
      // );
      // cookies.set("X-REFRESH-TOKEN", `${loginResponseData.refreshToken}`, {
      //   path: "/",
      //   expires: cookieExpires,
      // });
      setCookiesSync("X-REFRESH-TOKEN", loginResponseData.refreshToken);
      // cookies.set("no", myDecodedToken.no, {
      //   path: "/",
      //   expires: cookieExpires,
      // });
      setCookiesSync("no", myDecodedToken.no);

      if (loginResponseData.autoToken) {
        setCookiesSync("autoToken", loginResponseData.autoToken);
        // cookies.set("autoToken", `${loginResponseData.autoToken}`, {
        //   path: "/",
        //   expires: cookieExpires,
        // });
      }
      let data = "";

      await axios.get("/api/mb/member/my-info").then((res) => {
        data = res.data.data;
        setCookiesSync("favInfo", {
          defaultTp: data.member.mainTp, //설정에서 세팅하는 tp
          visibleTp: data.member.mainTp, //메인 화면에서 변경시키는 tp
          favMk: data.member.favMk,
          favMt: data.member.favMt,
        });
        // cookies.set(
        //   "favInfo",
        //   {
        //     defaultTp: data.member.mainTp, //설정에서 세팅하는 tp
        //     visibleTp: data.member.mainTp, //메인 화면에서 변경시키는 tp
        //     favMk: data.member.favMk,
        //     favMt: data.member.favMt,
        //   },
        //   {
        //     path: "/",
        //     expires: cookieExpires,
        //   }
        // );
      });
      // setAppData();
      window.loginComplete1 = function (authKey, pushUrl) {
        setIsRender(true);
        // location.href = `http://${window.location.host}/`;
        // _this.hideSplash();
      };

      if (window.Android) {
        window.Android.login(
          myDecodedToken.no,
          data.tag,
          data.member.mktPushYn,
          "loginComplete1",
        );
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.ios
      ) {
        // Call iOS interface
        var message = {
          command: "login",
          id: myDecodedToken.no,
          tag: data.tag,
          adYn: data.member.mktPushYn,
          func: "loginComplete1",
        };
        window.webkit.messageHandlers.ios.postMessage(message);
      }
      setIsRender(true);
    }
  }, [loginSuccess]);

  useEffect(async () => {
    if (loginFail) {
      window.logoutReturnFunc = () => {
        cookies.remove("favInfo", { path: "/" });
        cookies.remove("X-AUTH-TOKEN", { path: "/" });
        cookies.remove("X-REFRESH-TOKEN", { path: "/" });
        cookies.remove("autoToken", { path: "/" });
        setAppData();
        setIsRender(true);
        dispatch(logoutAction());

        dispatch(
          loadMainAction({
            schTp: "1",
            schStore: "2701",
          }),
        );
      };
      logout("logoutReturnFunc");
    }
  }, [loginFail]);

  useEffect(async () => {
    // window.getAppDataReturn = (text) => {
    //   alert('getAppDataReturn : ' + text);
    //   if(text) {
    //     let json = JSON.parse(text);
    //     if (json['X-AUTH-TOKEN']) {
    //       setCookiesSync("X-AUTH-TOKEN", json['X-AUTH-TOKEN'] || cookies.get("X-AUTH-TOKEN"));
    //       setCookiesSync("X-REFRESH-TOKEN", json['X-REFRESH-TOKEN'] || cookies.get("X-REFRESH-TOKEN"));
    //       setCookiesSync("no", json.no || cookies.get("no"));
    //       setCookiesSync("checked", json.checked || cookies.get("checked"));
    //       setCookiesSync("autoToken", json.autoToken || cookies.get("autoToken"));
    //       setCookiesSync("favInfo", json.favInfo || cookies.get("favInfo"));
    //     }
    //   }
    //   // autoLogin();
    // }
    getAppData(autoLogin);
  }, []);

  const [drawerHigh, setDrawerHigh] = useState(false);
  const handleDrawerHighOpen = () => {
    setDrawerHigh(true);
  };
  const handleDrawerHighClose = () => {
    setDrawerHigh(false);
  };

  const logout = (returnFunc) => {
    if (window.Android) {
      window.Android.logout(returnFunc);
    } else if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.ios
    ) {
      // Call iOS interface
      var message = {
        command: "logout",
        func: returnFunc,
      };
      window.webkit.messageHandlers.ios.postMessage(message);
    } else {
      cookies.remove("favInfo", { path: "/" });
      cookies.remove("X-AUTH-TOKEN", { path: "/" });
      cookies.remove("X-REFRESH-TOKEN", { path: "/" });
      cookies.remove("autoToken", { path: "/" });
      dispatch(logoutAction());

      dispatch(
        loadMainAction({
          schTp: "1",
          schStore: "2701",
        }),
      );
      setIsRender(true);
    }
  };

  const autoLogin = async () => {
    let checked = cookies.get("checked") || "";
    let autoToken = cookies.get("autoToken") || "";

    if (checked == "true" && autoToken) {
      let form = {
        grantType: "auto",
        username: autoToken,
      };
      dispatch(loginRequestAction(form));
    } else {
      window.logoutReturnFunc = () => {
        cookies.remove("favInfo", { path: "/" });
        cookies.remove("X-AUTH-TOKEN", { path: "/" });
        cookies.remove("X-REFRESH-TOKEN", { path: "/" });
        cookies.remove("autoToken", { path: "/" });
        setAppData();
        setIsRender(true);
        dispatch(logoutAction());

        dispatch(
          loadMainAction({
            schTp: "1",
            schStore: "2701",
          }),
        );
      };
      logout("logoutReturnFunc");
    }
  };

  return (
    <div className="App">
      <BrowserRouter>
        <Router>
          {isRender && (
            <>
              <RouteWatch />
              <div className="App-header">
                <Top />
              </div>
              <div
                className={
                  location.pathname.indexOf("guide") != -1
                    ? "App-body guide-wrap"
                    : "App-body"
                }
                style={{
                  paddingBottom: location.pathname == "/" ? `${rem(80)}` : "0",
                }}
              >
                <div
                  className="App-contents"
                  style={{
                    paddingTop: location.pathname !== "/login" ? null : 0,
                  }}
                >
                  <CacheSwitch>
                    {Routes.map((route) => {
                      if (route.auth == true) {
                        return (
                          <AuthRoute
                            key={route.path}
                            exact
                            cacheKey={route.path}
                            path={route.path}
                            component={route.component}
                            route={route}
                          />
                        );
                      } else {
                        if (route.cache == true) {
                          return (
                            <CacheRoute
                              key={route.path}
                              cacheKey={route.path}
                              exact
                              path={route.path}
                              component={route.component}
                            />
                          );
                        } else {
                          return (
                            <Route
                              key={route.path}
                              exact
                              path={route.path}
                              component={route.component}
                            />
                          );
                        }
                      }
                    })}
                    <Route path={"*"} key="404" component={NotFound} />
                  </CacheSwitch>
                </div>
              </div>
              {location.pathname == "/" && (
                // <div className="App-footer">
                <div
                  className={window.Android ? "App-footer" : "App-footer-ios"}
                >
                  <Bottom handleDrawerHighOpen={handleDrawerHighOpen} />
                </div>
              )}
              <CommonComponent />
            </>
          )}
        </Router>
      </BrowserRouter>
    </div>
  );
}

export default App;
